import React, { useEffect, useState } from "react";
import http from "../../../../../services/http";
import { Card } from "antd";
import moment from "moment";

function RecentUsers() {
  // STATES
  const [data, setData] = useState([]);

  // HELPERS
  const getStats = async () => {
    const { data } = await http.get(`recently-loggedin-users`);
    setData(data);
  };

  // HOOKS
  useEffect(() => {
    getStats();
  }, []);

  return (
    <Card className="chart-box">
      <div className="top-header">
        <h3>Recent Users</h3>
      </div>
      <ul className="users-listing">
        {data?.map((user) => (
          <li key={user.id}>
            <span>
              {user.first_name ?? ""} {user.last_name ?? ""}
            </span>
            <span>{user.email}</span>
            <span className="logged-time">
              <span>Last login</span>
              <span>
                {user?.last_login
                  ? moment(user?.last_login).format("Do MM YYYY, hh:mm a")
                  : "-"}
              </span>
            </span>
          </li>
        ))}
      </ul>
    </Card>
  );
}

export default RecentUsers;
